const TYPES = {
  SET_NOTIFICATION: 'notification/SET_NOTIFICATION',
  CLEAR_NOTIFICATION: 'notification/CLEAR_NOTIFICATION',
};

const setNotification = (message, variant, startIcon, persist = false) => ({
  type: TYPES.SET_NOTIFICATION,
  payload: { message, variant, startIcon, persist },
});

const clearNotification = () => ({
  type: TYPES.CLEAR_NOTIFICATION,
});

export {
  TYPES,
  setNotification,
  clearNotification,
};

export default {
  setNotification,
  clearNotification,
};
